import { render } from "./DetailedAccounts.vue?vue&type=template&id=0d20a0d3&scoped=true"
import script from "./DetailedAccounts.vue?vue&type=script&lang=js"
export * from "./DetailedAccounts.vue?vue&type=script&lang=js"

import "./DetailedAccounts.vue?vue&type=style&index=0&id=0d20a0d3&scoped=true&lang=css"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d20a0d3"]])

export default __exports__